/**
 * @Author: v_jppjpeng
 * @Date: 2023-6-14 20:07:49
 * @Explain: axios - 统一处理
 */
import axios from 'axios';
import { setReqConfig, onResError, onResSuccess } from './interfaceUtils';
// utils
import { API, isDev } from '@/config';

const baseURL = '/passport';

const instance = axios.create({
  baseURL: isDev ? baseURL : API.apiHost + baseURL,
  timeout: 100 * 1000, // 100S
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => config,
  (error) => {
    console.error('request.use', error);
    return Promise.reject(error);
  },
);

// 响应拦截器，做统一处理
instance.interceptors.response.use(
  (response) => {
    const responseData = response.data;

    onResSuccess(response);

    return responseData || {};
  },
  (error) => {
    let config: any = error?.config;
    // 是否弹出error提示框拦截
    let unUseCommonMsg = config?.params?.unUseCommonMsg;
    if (!unUseCommonMsg) onResError(error);
    return Promise.reject(error);
  },
);

export default instance;
